import React from 'react';

import type {WikiArticleFragment} from '../../../generated/types';
import {EntitySeo} from '../../../lib/seo';
import {buildUrl} from '../../../lib/routes';
import {wikiTypeTitles} from '../infobox';
import type {WikiInfobox} from '../infobox';
import {wikiDescription} from './wiki-seo-text';

export const WikiSeo: React.FC<{item: WikiArticleFragment}> = ({item}) => {
	const types = wikiTypeTitles(item.types).map((type) => type.toLowerCase());
	const infobox = (item.infobox || {}) as WikiInfobox;
	const image = infobox.image || infobox.locator;
	const crumbs = [...item.ancestors, item].map((article) => ({
		name: article.title,
		path: buildUrl('wikiArticle', {id: article.id}),
	}));
	return (
		<EntitySeo
			entity={{...item, images: image ? [{path: image.path, description: image.caption || item.title}] : []}}
			section="wiki"
			kind={types.length ? `${types.join(', ')} Забытых Королевств` : 'статья о Забытых Королевствах'}
			description={wikiDescription(item, types)}
			path={buildUrl('wikiArticle', {id: item.id})}
			og={{kind: 'wiki'}}
			crumbs={crumbs}
			keywords={['Забытые Королевства', 'Forgotten Realms', 'Фейрун', ...types]}
			rulesNote={false}
		/>
	);
};
